import sum from './sum';
export default (array, getter) => sum(array, getter) / array.length;



// WEBPACK FOOTER //
// ./app/src/average.js